import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    { staticClass: "hierarchy__row hierarchy__row--group-headers" },
    [
      _c("th", { staticClass: "border-right" }, [
        _c("span", { staticClass: "d-inline-flex align-center" }, [
          _vm.isGridViewLoading
            ? _c(
                "span",
                [
                  _c(
                    VIcon,
                    { staticClass: "fa-spin", attrs: { color: "pimary" } },
                    [_vm._v("autorenew")]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("gridView.tooltips.loading"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "border-right", attrs: { colspan: "4" } }, [
        _vm._v(_vm._s(_vm.$t("gridView.salesMetrics"))),
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "border-right", attrs: { colspan: "3" } }, [
        _vm._v("\n    " + _vm._s(_vm.$t("gridView.margin")) + "\n  "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.selectedCompetitors.length, function (competitorIndex, index) {
        return _c(
          "th",
          {
            key: competitorIndex,
            staticClass: "border-right",
            attrs: { colspan: _vm.competitorColumnsPerGroup },
          },
          [
            _c(
              VRow,
              { attrs: { align: "center", dense: "", "no-gutters": "" } },
              [
                !_vm.isAgGridProductListEnabled ||
                (_vm.isAgGridProductListEnabled && index === 0)
                  ? _c("div", { staticClass: "pr-1" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("gridView.priceDistance")) +
                          "\n      "
                      ),
                    ])
                  : _c("div", [_vm._v(" ")]),
                _vm._v(" "),
                _vm.isAgGridProductListEnabled && index === 0
                  ? _c("div", [_c("competitors-selector")], 1)
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.isAgGridProductListEnabled
              ? _c(
                  VRow,
                  {
                    staticClass: "mt-2",
                    attrs: { dense: "", "no-gutters": "" },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.selectedCompetitors[competitorIndex - 1]
                            .competitorDisplayDescription
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _c(
                  VRow,
                  { attrs: { dense: "", "no-gutters": "" } },
                  [
                    _c("competitor-filter", {
                      attrs: {
                        disabled: _vm.isGridViewLoading,
                        "selected-competitor":
                          _vm.selectedCompetitors[competitorIndex - 1],
                      },
                      on: {
                        selectCompetitor: function ($event) {
                          return _vm.selectCompetitor(
                            $event,
                            competitorIndex - 1
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("th", { staticClass: "border-right" }, [
        _vm._v(_vm._s(_vm.$t("gridView.tension"))),
      ]),
      _vm._v(" "),
      _c("th", [_vm._v(_vm._s(_vm.$t("gridView.changes")))]),
      _vm._v(" "),
      !_vm.isAgGridProductListEnabled ? _c("th") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }